import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
interface RelatedPage {
  title: string;
  image: string;
  link: string;
}
interface RelatedPagesProps {
  title?: string;
  pages: RelatedPage[];
}
export function RelatedPages({
  title = 'Explore More',
  pages
}: RelatedPagesProps) {
  if (!pages || pages.length === 0) return null;
  return <section className="py-16 border-t border-club-border mt-16" data-id="element-279">
      <h3 className="font-serif text-3xl mb-8 text-club-green" data-id="element-280">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-281">
        {pages.map((page, idx) => <Link key={idx} to={page.link} className="group block" data-id="element-282">
            <div className="aspect-[4/3] overflow-hidden rounded-sm mb-4" data-id="element-283">
              <img src={page.image} alt={page.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-284" />
            </div>
            <h4 className="text-xl mb-2 group-hover:text-club-gold transition-colors" data-id="element-285">
              {page.title}
            </h4>
            <span className="inline-flex items-center text-sm font-medium text-club-green group-hover:text-club-gold transition-colors" data-id="element-286">
              View Details <ArrowRight size={14} className="ml-1" data-id="element-287" />
            </span>
          </Link>)}
      </div>
    </section>;
}